const FETCH_RECENT_LISTING = 'recent_listings/FETCH_RECENT_LISTING';
const FETCH_RECENT_LISTING_SUCCESS = 'recent_listings/FETCH_RECENT_LISTING_SUCCESS';
const FETCH_RECENT_LISTING_FAILURE = 'recent_listings/FETCH_RECENT_LISTING_FAILURE';

export default {
  FETCH_RECENT_LISTING,
  FETCH_RECENT_LISTING_SUCCESS,
  FETCH_RECENT_LISTING_FAILURE,
};